import React, { Component } from 'react';
import './App.css';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import Main from './components/main';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store/store';
import ScrollToTop from './ScrollToTop';

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <Router >
          <ScrollToTop>
            <Main/>
          </ScrollToTop>
        </Router>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js